import React, { useState } from "react";
import { Link, Redirect } from "react-router-dom";
import signinpng from "../../assets/pale-welcome.svg";
import { signin, authenticate, isAuthenticated } from "../auth";

const Signin = () => {
  const [values, setValues] = useState({
    email: "",
    password: "",
    error: "",
    loading: false,
    redirectToReferrer: false,
  });

  const { email, password, loading, error, redirectToReferrer } = values;

  const handleChange = (name) => (event) => {
    setValues({ ...values, error: false, [name]: event.target.value });
  };

  const clickSubmit = (e) => {
    e.preventDefault();
    setValues({ ...values, error: false, loading: true });
    signin({ email, password }).then((data) => {
      if (data.email || data.password) {
        setValues({
          ...values,
          error: data.email || data.password,
          loading: false,
        });
      } else {
        authenticate(data, () => {
          setValues({
            ...values,
            redirectToReferrer: true,
          });
        });
      }
    });
  };
  const showError = () => {
    return (
      <div
        className="alert alert-danger"
        style={{ display: error ? "" : "none" }}
      >
        {error}
      </div>
    );
  };
  const showLoading = () =>
    loading && (
      <div className="alert alert-info">
        <h2>Loading...</h2>
      </div>
    );

  const redirectUser = () => {
    if (isAuthenticated()) {
      return <Redirect to="/" />;
    }
  };

  return (
    <div className="container">
      <div className="row">
        <div className="col-sm-6">
          <img src={signinpng} alt="" />
        </div>
        <div className="col-sm-4" style={{ marginTop: "10%" }}>
          <h2 className="text-muted mb-4">Sign In</h2>
          {showLoading()}
          {showError()}
          <form>
            <div className="mb-3 ">
              <input
                type="email"
                className="form-control"
                onChange={handleChange("email")}
                placeholder="Email address"
                value={email}
              />
            </div>
            <div className="mb-3">
              <input
                type="password"
                className="form-control"
                onChange={handleChange("password")}
                placeholder="Password"
                value={password}
              />
            </div>

            <button
              onClick={clickSubmit}
              type="submit"
              className="btn btn-success btn-lg btn-block"
            >
              Log in
            </button>
          </form>
          <p className="float-right mt-3">
            Don't have an account? <Link to="/signup">Signup</Link>
          </p>
        </div>
      </div>
      {redirectUser()}
    </div>
  );
};

export default Signin;
